module.exports = __webpack_public_path__ + "img/jeet11-rummy.232ec986.png";